module.exports = __webpack_public_path__ + "img/partner_01.68659fe1.jpg";